import { cn } from "@/lib/utils";
import { formatTime } from "@/lib/formatTime";
import { useEffect } from "react";

interface TimerProps {
  timeRemaining: number;
  totalTime: number;
  mode: 'work' | 'break';
  isRunning: boolean;
  wakeLockActive?: boolean;
}

export default function Timer({ timeRemaining, totalTime, mode, isRunning, wakeLockActive }: TimerProps) {
  // Ensure we have valid numbers for the progress calculation
  const progress = Math.min(100, Math.max(0, totalTime > 0 ? ((totalTime - timeRemaining) / totalTime) * 100 : 0));
  const formattedTime = formatTime(timeRemaining || 0);
  
  // Calculate circle properties
  const size = 280;
  const strokeWidth = 25;
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (progress / 100) * circumference;
  
  return (
    <div className="relative flex items-center justify-center">
      <svg
        width={size}
        height={size}
        className="transform -rotate-90"
      >
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          className="stroke-muted"
          fill="none"
        />
        
        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          className={cn(
            "transition-all duration-300 ease-in-out fill-none",
            mode === 'work' 
              ? "stroke-red-500" 
              : "stroke-green-500"
          )}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      
      {/* Timer text */}
      <div className="absolute flex items-center justify-center">
        <div 
          className="text-5xl font-bold text-primary font-mono"
        >
          {formattedTime}
        </div>
      </div>
      

    </div>
  );
}
